import React from 'react'
import images from '../images/balcony.jpg'
import pics from '../images/icon.jpeg'
import image from '../images/staycool.jpg'

const Logindemo3 = () => {
    return (
        <>
            <div className="flex items-center bg-green-600 h-20 mb-1 ">
                {/* Logo Section */}
                <div className="flex items-center space-x-2 ml-8 px-3 ">
                    <img src={pics} 
                    alt="stay" 
                    className="h-10" />
                </div>
                <div className=" px-2 h-full w-[145px] mt-4">
                    <svg
                        className="block mt-4 wx-full ml-full h-full"
                        viewBox="0 0 160 80"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="none"
                    >
                        <path
                            d="M160,0 C105,0 105,80 0,80 L160,80 Z"
                            fill="#ffffff"
                        />
                    </svg>
                </div>

                {/* Spacer */}
                <div className="w-6" /> {/* Optional spacing between logo and nav */}

                {/* Navigation Section */}
                <nav className="flex justify-end items-center pl-[300px] px-8 mt-12 bg-white w-full h-full  text-green-600">
                    <ul className="flex space-x-6 font-medium font-semibold mb-3">
                        <li><a href="#" className="hover:underline">Home</a></li>
                        <li><a href="#" className="hover:underline">About Us</a></li>
                        <li><a href="#" className="hover:underline">Customer Care</a></li>
                    </ul>
                </nav>
            </div>
            <div className='grid grid-cols-2 h-full bg-blue-500'>
                <div className='w-full p-6 shadow-lg bg-white'>
                    <h1 className=' text-4xl block text-center text-outline-black font-bold text-blue-300'>Welcome <p className="flex justify-center text-green-800 text-outline-black">To</p></h1>
                    <div className='flex justify-center items-center py-2'>
                        <img
                            src={image}
                            alt="sample"
                            className="w-1/2 h-1/2"
                        />
                    </div>
                    <div className='ml-28'>
                        <div className='relative mt-3 py-2'>
                            <div className='absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none'>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-5 h-6 mt-8 text-gray-500"
                                    fill="currentColor"
                                    viewBox="0 0 640 640"
                                >
                                    <path d="M125.4 128C91.5 128 64 155.5 64 189.4C64 190.3 64 191.1 64.1 192L64 192L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 192L575.9 192C575.9 191.1 576 190.3 576 189.4C576 155.5 548.5 128 514.6 128L125.4 128zM528 256.3L528 448C528 456.8 520.8 464 512 464L128 464C119.2 464 112 456.8 112 448L112 256.3L266.8 373.7C298.2 397.6 341.7 397.6 373.2 373.7L528 256.3zM112 189.4C112 182 118 176 125.4 176L514.6 176C522 176 528 182 528 189.4C528 193.6 526 197.6 522.7 200.1L344.2 335.5C329.9 346.3 310.1 346.3 295.8 335.5L117.3 200.1C114 197.6 112 193.6 112 189.4z" />
                                </svg>
                            </div>
                            <label htmlFor="email" className='items-center block text-base mb-2'>Email</label>
                            <input
                                type="text"
                                id="Email"
                                className="w-3/4 pl-10 py-2 border border-green-300 rounded bg-green-200 text-sm focus:outline focus:ring-0"
                                placeholder='Enter Email'
                            />
                        </div>

                        <div className="relative mt-3 py-2">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-5 h-6 mt-8 text-gray-500"
                                    fill="currentColor"
                                    viewBox="0 0 640 640"
                                >
                                    <path d="M256 160L256 224L384 224L384 160C384 124.7 355.3 96 320 96C284.7 96 256 124.7 256 160zM192 224L192 160C192 89.3 249.3 32 320 32C390.7 32 448 89.3 448 160L448 224C483.3 224 512 252.7 512 288L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 288C128 252.7 156.7 224 192 224z" />
                                </svg>
                            </div>
                            <label htmlFor="password" className="block text-base mb-2">Password</label>
                            <input
                                type="password"
                                id="password"
                                placeholder="Enter Password"
                                className="w-3/4 pl-10 py-2 border border-green-300 rounded bg-green-200 text-sm focus:outline focus:ring-0"
                            />
                        </div>

                        <div className=' flex justify-between mt-3 items-center py-2'>
                            <div className='appearance-none checked:bg-blue-500'>
                                <input type="checkbox" />
                                <label className='p-1'>Remember Me?</label>
                            </div>
                            <div>
                                <a href='#' className='text-green-800 font-semibold hover:underline hover:text-green-500 mr-32'>Forget Password?</a>
                            </div>


                        </div>

                        <div className='mt-5'>
                            <button className='border-2 border-green-700 bg-green-500 text-white py-1 w-3/4 rounded-md hover:bg-transparent hover:text-green-500 font-semibold'>
                                Login
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <img
                        src={images}
                        alt="sample"
                        className="w-full h-[640px]"
                    />
                </div>
            </div>
        </>
    )
}

export default Logindemo3